import React from 'react';
import './TechStackPanel.css';

const TechStackPanel = ({ proofT }) => {
  return (
    <div className="tab-panel active">
      <div className="tech-stack-overview">
        <div className="tech-stack-intro">
          <h3>{proofT('techStack.intro.title')}</h3>
          <p>{proofT('techStack.intro.description')}</p>
        </div>
        
        <div className="tech-stack-grid">
          {/* Rust microservices - Runtime */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <span className="service-icon service-icon--rust" aria-hidden="true">Rust</span>
                <h4>{proofT('techStack.services.rustMicroservices.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.runtime')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.rustMicroservices.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.rustMicroservices.advantages.autoScaling.label')}</strong> {proofT('techStack.services.rustMicroservices.advantages.autoScaling.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.rustMicroservices.advantages.highPerformance.label')}</strong> {proofT('techStack.services.rustMicroservices.advantages.highPerformance.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.rustMicroservices.advantages.availability.label')}</strong> {proofT('techStack.services.rustMicroservices.advantages.availability.description')}
                </div>
              </div>
            </div>
          </div>

          {/* Azure Foundry - Compute */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/azure/foundry-test.png" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.azureFoundry.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.compute')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.azureFoundry.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.azureFoundry.advantages.dataSovereignty.label')}</strong> {proofT('techStack.services.azureFoundry.advantages.dataSovereignty.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.azureFoundry.advantages.complianceReady.label')}</strong> {proofT('techStack.services.azureFoundry.advantages.complianceReady.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.azureFoundry.advantages.enterpriseSecurity.label')}</strong> {proofT('techStack.services.azureFoundry.advantages.enterpriseSecurity.description')}
                </div>
              </div>
            </div>
          </div>

          {/* MongoDB - Database */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/tech/mongodb.png" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.mongodb.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.database')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.mongodb.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.mongodb.advantages.flexibleSchema.label')}</strong> {proofT('techStack.services.mongodb.advantages.flexibleSchema.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.mongodb.advantages.scalability.label')}</strong> {proofT('techStack.services.mongodb.advantages.scalability.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.mongodb.advantages.vectorSearch.label')}</strong> {proofT('techStack.services.mongodb.advantages.vectorSearch.description')}
                </div>
              </div>
            </div>
          </div>

          {/* PostgreSQL, ClickHouse, ScyllaDB - Database */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <span className="service-icon service-icon--datastores" aria-hidden="true">PG · CH · S</span>
                <h4>{proofT('techStack.services.operationalDataStores.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.database')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.operationalDataStores.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.operationalDataStores.advantages.oltp.label')}</strong> {proofT('techStack.services.operationalDataStores.advantages.oltp.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.operationalDataStores.advantages.analytics.label')}</strong> {proofT('techStack.services.operationalDataStores.advantages.analytics.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.operationalDataStores.advantages.wideColumn.label')}</strong> {proofT('techStack.services.operationalDataStores.advantages.wideColumn.description')}
                </div>
              </div>
            </div>
          </div>

          {/* Redis - Cache */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/tech/redis.png" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.redis.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.cache')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.redis.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.redis.advantages.lowLatency.label')}</strong> {proofT('techStack.services.redis.advantages.lowLatency.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.redis.advantages.inCluster.label')}</strong> {proofT('techStack.services.redis.advantages.inCluster.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.redis.advantages.kedaScaling.label')}</strong> {proofT('techStack.services.redis.advantages.kedaScaling.description')}
                </div>
              </div>
            </div>
          </div>

          {/* NATS JetStream - Messaging */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/tech/nats.png" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.natsJetstream.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.messaging')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.natsJetstream.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.natsJetstream.advantages.realTime.label')}</strong> {proofT('techStack.services.natsJetstream.advantages.realTime.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.natsJetstream.advantages.highThroughput.label')}</strong> {proofT('techStack.services.natsJetstream.advantages.highThroughput.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.natsJetstream.advantages.eventDriven.label')}</strong> {proofT('techStack.services.natsJetstream.advantages.eventDriven.description')}
                </div>
              </div>
            </div>
          </div>

          {/* Azure Key Vault - Security */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/azure/key-vault.svg" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.keyVault.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.security')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.keyVault.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.keyVault.advantages.centralizedSecurity.label')}</strong> {proofT('techStack.services.keyVault.advantages.centralizedSecurity.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.keyVault.advantages.hardwareSecurity.label')}</strong> {proofT('techStack.services.keyVault.advantages.hardwareSecurity.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.keyVault.advantages.auditCompliance.label')}</strong> {proofT('techStack.services.keyVault.advantages.auditCompliance.description')}
                </div>
              </div>
            </div>
          </div>

          {/* Kubernetes (AKS) - Platform / API Gateway */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/tech/kubernetes.png" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.kubernetes.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.apiGateway')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.kubernetes.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.kubernetes.advantages.secureAccess.label')}</strong> {proofT('techStack.services.kubernetes.advantages.secureAccess.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.kubernetes.advantages.ingress.label')}</strong> {proofT('techStack.services.kubernetes.advantages.ingress.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.kubernetes.advantages.scaleToZero.label')}</strong> {proofT('techStack.services.kubernetes.advantages.scaleToZero.description')}
                </div>
              </div>
            </div>
          </div>

          {/* Monitoring & Observability */}
          <div className="tech-stack-card">
            <div className="tech-stack-header">
              <div className="tech-stack-title">
                <img src="/icons/tech/monitoring.svg" alt="" className="service-icon" onError={(e) => { e.target.style.display = 'none'; }} />
                <h4>{proofT('techStack.services.monitoring.name')}</h4>
              </div>
              <span className="tech-category-badge">{proofT('techStack.categories.monitoring')}</span>
            </div>
            <div className="tech-stack-content">
              <p className="tech-description">{proofT('techStack.services.monitoring.description')}</p>
              <div className="tech-advantages">
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.monitoring.advantages.proactive.label')}</strong> {proofT('techStack.services.monitoring.advantages.proactive.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.monitoring.advantages.performance.label')}</strong> {proofT('techStack.services.monitoring.advantages.performance.description')}
                </div>
                <div className="advantage-item">
                  <strong>{proofT('techStack.services.monitoring.advantages.dashboards.label')}</strong> {proofT('techStack.services.monitoring.advantages.dashboards.description')}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechStackPanel;
